import React from 'react';

export interface PromoBannerProps {
  message: React.ReactNode;
}

export const PromoBanner: React.FC<PromoBannerProps> = ({ message }) => {
  return (
    <div className="bg-palette-3 text-white border-b border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 text-sm font-semibold text-center">
        {message}
      </div>
    </div>
  );
};

